<template>
  <div class="global-search" @click.outside="closeDropdown">
    <div class="search-input-wrapper">
      <input
        type="text"
        v-model="searchTerm"
        @input="onInput"
        placeholder="Suche..."
        class="search-input"
      />
      <div v-if="!searchTerm" class="magnifying-glass"><GlobalSearchLogo class="w-6 h-6"/></div>
      <div v-if="searchTerm" class="magnifying-glass clickable">
        <Button variant="outline" size="sm" @click="resetFilters" :title="getFilterButtonText()">
				     <XCircle/>
				</Button>
      </div>

    </div>

    <ul v-if="dropdownOpen && searchResults.length" class="dropdown" style="width: max-content">
      <li
        v-for="item in searchResults"
        :key="item.entity"
        @click="goToEntity(item.entity)"
        class="dropdown-item"
      >
        {{ item.entity }} ({{ item.count }})
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Button } from "@/components/ui/button"
import { XCircle } from "lucide-vue-next"

import GlobalSearchLogo from '@/components/images/globalsearch.svg'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();


const searchTerm = ref('');
const searchResults = ref([]);
const dropdownOpen = ref(false);

let debounceTimeout = null;

// Called whenever the user types
function onInput() {
  dropdownOpen.value = true;

  // Debounce input to avoid too many requests
  if (debounceTimeout) clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(fetchResults, 300);
}

// Fetch results from Rails backend
async function fetchResults() {
  if (!searchTerm.value.trim()) {
    searchResults.value = [];
    return;
  }

  try {
    const response = await fetch(`/search?query=${encodeURIComponent(searchTerm.value)}`);
    if (!response.ok) throw new Error('Failed to fetch');
    const data = await response.json();

    searchResults.value = data;
  } catch (err) {
    console.error(err);
    searchResults.value = [];
  }
}

function closeDropdown() {
  dropdownOpen.value = false;
}

const emit = defineEmits(['globalsearch'])

function goToEntity(entity) {
  closeDropdown()
  emit('globalsearch', {entity, search: searchTerm.value})
}

function resetFilters() {
    const url = new URL(window.location.href);
    url.searchParams.set("reset_filter_button", 1);
    window.location.href = url.toString();
}

function getFilterButtonText() {
  return t('view.reset_filter')
}

</script>

<style scoped>
.global-search {
  position: relative;
}

.search-input-wrapper {
  position: relative;
}

.search-input {
  width: 100%;
  padding: 6px 30px 6px 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.magnifying-glass {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.magnifying-glass.clickable {
  pointer-events: auto;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 2px;
  z-index: 100;
}

.dropdown-item {
  padding: 6px 10px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f0f0f0;
}
</style>
